export const RESULT_PER_PAGE = 4;
